import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = () => map.commands.aiGenerateFamdt(map.selectedNodes)

    return {
        label: '新建程序方案（已有数据表）',
        onClick,
    }
}
